import React from 'react';
import ReactDOM from 'react-dom';
import PlanningModal from './modal/PlanningModal';
import { Label, Popup } from 'semantic-ui-react';
import $ from 'jquery';
import { withReferer } from 'plugins/contextual-back';
import { columnWidth, renderList } from 'utils/async-list';
import { Column } from 'react-virtualized';
import { renderCaseCustomer } from '../cases/common';

function displayModal(modal) {
  // Appending content to body
  $(document.body).append(modal);

  // Handling approve button
  const $modal = $('#modal-root');

  $modal
    .modal({
      onApprove: element => {},
      autofocus: false,
    })
    .modal('show');
}

const displayPlanningModal = (id, caseId) => {
  const root = document.getElementById('modal-root');
  const workersData = window.__WORKERS__;

  const onClose = () => {
    $(root).modal('hide');
  };

  if (root && workersData) {
    ReactDOM.unmountComponentAtNode(root);

    const modalContent = ReactDOM.render(
      <PlanningModal
        id={id}
        caseId={caseId}
        workers={workersData}
        onClose={onClose}
      />,
      root
    );
    displayModal(modalContent);
  }
};

const renderInErrorActions = ({ rowData }) => {
  const id = rowData.id;

  const onReplanClick = evt => {
    evt.preventDefault();
    evt.stopPropagation();

    displayPlanningModal(id, rowData.caseId);
  };

  const renderButton = (
    <div className="ui buttons">
      <a className="ui basic green button" onClick={onReplanClick}>
        <i className="undo icon" />
        Replanifier
      </a>
    </div>
  );

  return renderButton;
};

function renderColumns(width) {
  return [
    <Column
      key="id"
      dataKey="id"
      cellRenderer={renderInErrorActions}
      width={columnWidth(width, 2)}
      label="Action"
    />,
    <Column
      key="name"
      dataKey="name"
      cellRenderer={renderCaseCustomer}
      width={columnWidth(width, 10)}
      label="Nom du chantier"
    />,
    <Column
      key="planningDate"
      dataKey="planningDate"
      width={columnWidth(width, 4)}
      label="Date"
    />,
  ];
}

function render(url, from) {
  const caseUrl = id => {
    const components = id.split('_');

    return withReferer(
      `/pco-manager/aast/cases/interventions/${components[1]}`,
      from
    );
  };

  const rowClickedUrl = id => caseUrl(id);
  const loadNextUrl = url;

  renderList(rowClickedUrl, loadNextUrl, renderColumns);
}

export default function list(ctx) {
  render(
    '/pco-manager/aast/interventions/error.json',
    '/pco-manager/aast/interventions/error'
  );
}



// WEBPACK FOOTER //
// ./src/modules/saas/aast/interventions/list-inerror.js